export const processaRegistrosDefaultIniciaisSimulacaoFinanceiraAporteRetiradaAnual = ( values ) => {

    if (!values.objPrevidenciaPrivada.simulacao) {

        values.objPrevidenciaPrivada.simulacao = []
    }
}



export const incrementaContPrevidenciaPrivadaSimulacao = ( values ) => {

    if (!values.objPrevidenciaPrivada.contSimulacao) {

        values.objPrevidenciaPrivada.contSimulacao = 0
    }

    values.objPrevidenciaPrivada.contSimulacao += 1
}
